import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import CountdownTimer from 'Components/Utility/CountdownTimer';

export default function StarDealProgressBar({ keysAvailablePercentage, starDealEndDate }) {
  const styling = {
    keys: {
      width: `${keysAvailablePercentage}%`,
    },
  };

  return (
    <div className="StarDealProgressBar CarouselPanel__section">
      <div className="progress">
        <div
          className="progress-bar progress-bar-striped progress-bar-animated star-deal"
          role="progressbar"
          style={styling.keys}
          aria-valuenow={keysAvailablePercentage}
          aria-valuemin="0"
          aria-valuemax="100"
          aria-label="Keys remaining"
          title="Keys remaining"
        />
        {keysAvailablePercentage >= 85 &&
          <div className="progress-timer progress-timer-overlay">
            {keysAvailablePercentage}% &nbsp;<FormattedMessage id="stardealprogressbar.remaininghigh" defaultMessage="Remaining" tagName="span" />
          </div>
        }
        {keysAvailablePercentage < 85 && keysAvailablePercentage >= 20 &&
          <div className="progress-timer progress-timer-overlay">
            {keysAvailablePercentage}% &nbsp;<FormattedMessage id="stardealprogressbar.remaining" defaultMessage="keys left" tagName="span" />
          </div>
        }
        {keysAvailablePercentage < 20 &&
          <div className="progress-timer progress-timer-overlay">
            <FormattedMessage id="stardealprogressbar.remaininglow" defaultMessage="Last Few Keys Remaining" tagName="span" />
          </div>
        }
      </div>

      <CountdownTimer featuredDeal value={starDealEndDate} />
    </div>
  );
}

StarDealProgressBar.propTypes = {
  keysAvailablePercentage: PropTypes.number,
  starDealEndDate: PropTypes.number,
};

StarDealProgressBar.defaultProps = {
  keysAvailablePercentage: 0,
  starDealEndDate: 0,
};
